import React from 'react'
import { Col, Dialog, Divider, InputField, Row, SelectField, Typography } from '../../../../ppui'
import { SALARY_DETAILS_CONST } from '../pay-kyc-const'
import { MdCurrencyRupee } from 'react-icons/md'


const PaymentModal = ({
  paymentData,
  onChangePayment,
  OnBlurePayment,
  paymentErr,
  onUpdatePayKyc,
  paymentModal,
  PaymentModalToggle,
  paymentloader
}) => {
  return (
    <Dialog
    title="Payment Structure"
    closeButton={true}
    fullWidth
    maxWidth="md"
    open={paymentModal}
    onClose={PaymentModalToggle}
    onSubmit={()=>onUpdatePayKyc(PaymentModalToggle)}
    btnLoading={paymentloader}
  >

  
    <Row rowGap>
      <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
        <SelectField
          defaultValue={paymentData?.salary_type}
          error={!!paymentErr?.salary_type}
          helperText={paymentErr?.salary_type}
          {...SALARY_DETAILS_CONST.salary_type}
          onChange={(e) => onChangePayment(e, "salary_type")}
          onBlur={(e) => OnBlurePayment(e, "salary_type")}
        />
      </Col>
      {
        paymentData?.salary_type === "fixed" && <>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              {...SALARY_DETAILS_CONST?.payment_mode}
              defaultValue={paymentData?.payment_mode}
              error={!!paymentErr?.payment_mode}
              helperText={paymentErr?.payment_mode}
              onChange={(e) => onChangePayment(e, "payment_mode")}
              onBlur={(e) => OnBlurePayment(e, "payment_mode")}
            />
          </Col>


          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              {...SALARY_DETAILS_CONST?.ammount}
              error={!!paymentErr?.ammount}
              helperText={paymentErr?.ammount}
              value={paymentData?.ammount}
              valueSinc={!!paymentData?.ammount}
              onChange={(e) => onChangePayment(e, "ammount")}
              onBlur={(e) => OnBlurePayment(e, "ammount")}
              suffix={<MdCurrencyRupee />}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
            defaultValue={paymentData?.payment_by}
            error={!!paymentErr?.payment_by}
            helperText={paymentErr?.payment_by}
           
              onChange={(e) => onChangePayment(e, "payment_by")}
              onBlur={(e) => OnBlurePayment(e, "payment_by")}
              {...SALARY_DETAILS_CONST?.payment_by}
            />
          </Col>
        </>
      }
      {
        paymentData?.salary_type === "wages" && <>


          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              error={!!paymentErr?.wages_type}
              helperText={paymentErr?.wages_type}
              defaultValue={paymentData?.wages_type}
              onChange={(e) => onChangePayment(e, "wages_type")}
              onBlur={(e) => OnBlurePayment(e, "wages_type")}
              {...SALARY_DETAILS_CONST?.wages_type}
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!paymentErr?.wages_rate}
              helperText={paymentErr?.wages_rate}
              value={paymentData?.wages_rate}
              onChange={(e) => onChangePayment(e, "wages_rate")}
              onBlur={(e) => OnBlurePayment(e, "wages_rate")}
              {...SALARY_DETAILS_CONST?.wages_rate}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
              error={!!paymentErr?.wages_payment_mode}
              helperText={paymentErr?.wages_payment_mode}
              defaultValue={paymentData?.wages_payment_mode}
              onChange={(e) => onChangePayment(e, "wages_payment_mode")}
              onBlur={(e) => OnBlurePayment(e, "wages_payment_mode")}
              {...SALARY_DETAILS_CONST?.wages_payment_mode}
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!paymentErr?.wages_days}
              helperText={paymentErr?.wages_days}
              value={paymentData?.wages_days}
              onChange={(e) => onChangePayment(e, "wages_days")}
              onBlur={(e) => OnBlurePayment(e, "wages_days")}
              {...SALARY_DETAILS_CONST?.wages_days}
     
            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
            error={!!paymentErr?.ammount}
            helperText={paymentErr?.ammount}
              value={paymentData?.ammount}
              valueSinc={!!paymentData?.ammount}
              onChange={(e) => onChangePayment(e, "ammount")}
              onBlur={(e) => OnBlurePayment(e, "ammount")}
              {...SALARY_DETAILS_CONST?.ammount}
              suffix={<MdCurrencyRupee />}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <SelectField
            error={!!paymentErr?.payment_by}
            helperText={paymentErr?.payment_by}
            defaultValue={paymentData?.payment_by}
              onChange={(e) => onChangePayment(e, "payment_by")}
              onBlur={(e) => OnBlurePayment(e, "payment_by")}
              {...SALARY_DETAILS_CONST?.payment_by}
            />
          </Col>
        </>
      }





    </Row>
    <Divider gap={20} />

{
paymentData?.payment_by==="account_transfer" &&
<>
 <Typography variant="h5">Bank Details</Typography>

<Row rowGap>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
   error={!!paymentErr?.bank_name}
   helperText={paymentErr?.bank_name}
     value={paymentData?.bank_name}
     valueSinc={!!paymentData?.bank_name}
     onChange={(e) => onChangePayment(e, "bank_name")}
     onBlur={(e) => OnBlurePayment(e, "bank_name")}
    {...SALARY_DETAILS_CONST?.bank_name}
  />
</Col>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
    error={!!paymentErr?.branch_name}
    helperText={paymentErr?.branch_name}
      value={paymentData?.branch_name}
      valueSinc={!!paymentData?.branch_name}
      onChange={(e) => onChangePayment(e, "branch_name")}
      onBlur={(e) => OnBlurePayment(e, "branch_name")}
    {...SALARY_DETAILS_CONST?.branch_name}
  />
</Col>
<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
      error={!!paymentErr?.account_number}
      helperText={paymentErr?.account_number}
        value={paymentData?.account_number}
        valueSinc={!!paymentData?.account_number}
        onChange={(e) => onChangePayment(e, "account_number")}
        onBlur={(e) => OnBlurePayment(e, "account_number")}
    {...SALARY_DETAILS_CONST?.account_number}
  />
</Col>

<Col sm={12} md={4} lg={4} xxl={3}>
  <InputField
    error={!!paymentErr?.ifsc_code}
    helperText={paymentErr?.ifsc_code}
      value={paymentData?.ifsc_code}
      valueSinc={!!paymentData?.ifsc_code}
      onChange={(e) => onChangePayment(e, "ifsc_code")}
      onBlur={(e) => OnBlurePayment(e, "ifsc_code")}
    {...SALARY_DETAILS_CONST?.ifsc_code}
  />
</Col>
</Row>

<Divider gap={20} />

</>
}
  </Dialog>
  )
}

export default PaymentModal
